(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-navigation"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.anchorNavigation-container').forEach((container) => {
    container.addEventListener('click', (event) => {
      const item = event.target.closest('.anchorNavigation-item');

      if (!item || item.closest('.anchorNavigation-container') !== container) {
        return;
      }

      container.querySelectorAll('.anchorNavigation-item').forEach((sibling) => {
        sibling.classList.toggle('active', sibling === item);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
